import { render, staticRenderFns } from "./ComparisonModal.vue?vue&type=template&id=6a3f3158"
import script from "./ComparisonModal.vue?vue&type=script&lang=js"
export * from "./ComparisonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports